import React from "react";
import "./App.css";
import "./Responsive.css";

import "bootstrap/dist/css/bootstrap.min.css";
import Pages from "./routes/Pages";
import { BrowserRouter } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";

function App() {
	return (
		<ParallaxProvider>
			<BrowserRouter>
				<div className="App">
					<section>
						<Pages />
					</section>
				</div>
			</BrowserRouter>
		</ParallaxProvider>
	);
}

export default App;
